import { AppConfigKeys } from '@rialtic/types'

/**
 * Keeps deep links and typed URLs out of flagged-off features; NavMenu hides
 * the entry points. Flags come from the shared store (`@rialtic/nuxt-shared`).
 */
const flaggedPathPrefixes: Array<{
  flag: AppConfigKeys
  prefixes: string[]
  redirectTo: (path: string) => string
}> = [
  {
    flag: AppConfigKeys.featureProviders,
    prefixes: ['/providers', '/dashboard/providers'],
    // All-LOB routes fall back to the all-LOB dashboard, single-LOB to its own.
    redirectTo: (path) => (path.startsWith('/dashboard') ? '/dashboard' : '/'),
  },
]

export default defineNuxtRouteMiddleware(async (to) => {
  if (import.meta.server || to.meta.public) return

  const matched = flaggedPathPrefixes.find(({ prefixes }) =>
    prefixes.some(
      (prefix) => to.path === prefix || to.path.startsWith(`${prefix}/`),
    ),
  )

  if (!matched) return

  const featureFlags = useFeatureFlags()
  await featureFlags.initialize()

  if (featureFlags.isEnabled(matched.flag)) return

  return navigateTo(matched.redirectTo(to.path), { replace: true })
})
